import request from '@/request'
// 活动时间判断
export const getBaseTime = data => {
  return request({
    url: '/exterior_intFtuSpNumberinfo/getBaseTime.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
// 获取书籍列表
export const getAllBook = data => {
  return request({
    url: '/exterior_intFtuSpBookinfo/getAllBook.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
// 首次进入判断
export const firstJoinPanduan = data => {
  return request({
    url: '/exterior_intFtuSpAccountinfo/firstJoinPanduan.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
// 首次进入
export const firstJoin = data => {
  return request({
    url: '/exterior_intFtuSpAccountinfo/firstJoin.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
// 获取书评数量
export const getAllCommentNum = data => {
  return request({
    url: '/exterior_intFtuSpCommentinfo/getAllCommentNum.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
// 获取首页书评内容
export const getComment = data => {
  return request({
    url: '/exterior_intFtuSpCommentinfo/getComment.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
// 填写书评
export const addComment = data => {
  return request({
    url: '/exterior_intFtuSpCommentinfo/addComment.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
// 书籍介绍
export const getBook = data => {
  return request({
    url: '/exterior_intFtuSpBookinfo/getBook.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
// 获取所有书评：热门
export const getAllCommentHot = data => {
  return request({
    url: '/exterior_intFtuSpCommentinfo/getAllCommentHot.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
// 获取所有书评：最新
export const getAllCommentNew = data => {
  return request({
    url: '/exterior_intFtuSpCommentinfo/getAllCommentNew.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
// 获取点赞数量
export const getThumbsNum = data => {
  return request({
    url: '/exterior_intFtuSpThumbsinfo/getThumbsNum.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
// 点赞
export const addThumbs = data => {
  return request({
    url: '/exterior_intFtuSpThumbsinfo/addThumbs.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
// 点赞取消
export const cancelThumbs = data => {
  return request({
    url: '/exterior_intFtuSpThumbsinfo/cancelThumbs.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
// 删除书评
export const deleteComment = data => {
  return request({
    url: '/exterior_intFtuSpCommentinfo/deleteComment.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
// 评论举报
export const addReport = data => {
  return request({
    url: '/exterior_intFtuSpRreportinfo/addReport.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
// 权限判断
export const getAuthority = data => {
  return request({
    url: '/exterior_intFtuSpAuthorityinfo/getAuthority.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
// 书评排行榜
export const getCommentRank = data => {
  return request({
    url: '/exterior_intFtuSpCommentinfo/getCommentRank.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
// 评论查询
export const getCommentReport = data => {
  return request({
    url: '/exterior_intFtuSpCommentinfo/getCommentReport.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
// 书籍排名
export const getBookRank = data => {
  return request({
    url: '/exterior_intFtuSpBookinfo/getBookRank.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
// 访问量
export const addReadcnt = data => {
  return request({
    url: '/exterior_intFtuSpNumberinfo/addReadcnt.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
